import TwinTrans from '../../../../../../../baseComponents/TwinTrans'
import { SetEditDeleteModalTy } from '../../../../../../../utils/hooks/useEditDeleteModal'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import { ShowOrderNotesIcon } from '../OrderTotal/Components/HeaderOrderTotal'

export interface OrderNotesDisplayerProps {
    notes: string
    setOpenModal: SetEditDeleteModalTy
}

const OrderNotesDisplayer: React.FC<OrderNotesDisplayerProps> = ({ notes, setOpenModal }) => {
    const { t } = useTwinTranslation()
    return (
        <div className='bg-gray-F7 px-24 py-8 mt-20'>
            <span><TwinTrans transKey='notesOfOrder'>Notas del pedido</TwinTrans></span>
            <div className='flex items-center font-light'>
                <div className='flex-auto'>
                    {notes.length > 377 ? notes.substring(0, 377) + '...' : notes}
                </div>
                <ShowOrderNotesIcon setOpenModal={setOpenModal} label={t('editNotes', 'Editar notas')} />
            </div>
        </div>
    )
}

export default OrderNotesDisplayer